import { generateUniqId } from '@/utils'
import { SET_CUSTOMER, AUTH_SUCCESS } from '../actions/auth'
import { 
  CART_CONFIRM, 
  ADD_TO_CART, 
  ADD_TO_TMP_CART, 
  REMOVE_FROM_CART, 
  REMOVE_FROM_TMP_CART, 
  RESET_CART, 
  RESET_TMP_CART, 
  CHANGE_ITM_QTY, 
  SAVE_CART, 
  SHOW_CART,
  HIDE_CART,
  SET_CART_VISIBILITY,
  SET_CART_USER_TOKEN,
  SET_CART_CUSTOMER,
  RESET_CART_ITEMS,
  STORE_OLD_CART,
  RECOVER_OLD_CART,
  UPDATE_TOTAL_QTY,
  RESET_OLD_CART,
  UPDATE_CART, 
  COMPARE_OLD_CART } from '../actions/cart'
import { SET_SNACK } from '@/store/actions/snackbar'
import { RepositoryFactory } from '@/repositories/RepositoryFactory'
const OrdersRepository = RepositoryFactory.get('orders')

let cart     = window.localStorage.getItem('cart')
let totalQty = window.localStorage.getItem('totalQty')
let oldCart  = window.localStorage.getItem('oldCart')
let defaultCart = {
  guid: generateUniqId(),
  items: [],
  customer: {},
  userToken: '',
}

if (cart) {
  cart = JSON.parse(cart)
  Object.keys(defaultCart).forEach(key => {
    if (!Object.prototype.hasOwnProperty.call(cart, key)) {
      cart[key] = defaultCart[key]
    }
  })
  cart.items.forEach((item, i) => {
    item.getUnitPrice = function() {
      if (this.discount !== null) {
        return parseFloat(this.unitPrice * (1 - (this.discount / 100)))
      }

      return parseFloat(this.unitPrice)
    }
    
    if (Object.prototype.hasOwnProperty.call(item.reference, 'productDesc')) {
      cart.items[i].reference = {
        id: item.reference.id,
        exRef: item.reference.exRef,
        name: item.reference.name,
        thumbnail: item.reference.thumbnail,
        description: item.reference.description,
        defaultProduct: {
          id: item.reference.defaultProduct.id,
          name: item.reference.defaultProduct.name,
        },
      }
    }
  })
}

if (oldCart) {
  oldCart = JSON.parse(oldCart)
}

/**
 * ==============================
 * STATE
 * ==============================
 */

const state = {
  cart: cart ?? defaultCart,
  tmpCart: {
    items: [],
  },
  totalQty: totalQty ? parseInt(totalQty) : 0,
  cartShown: false,
  oldCart: oldCart ?? {}
}

/**
 * ==============================
 * GETTERS
 * ==============================
 */

const getters = {
  getItems: state => state.cart.items,
  isCartShown: state => state.cartShown,
  cartQty: state => state.totalQty,
  getCartTotal: state => {
    let totalPrice = state.cart.items.reduce((acc, curr) => {
      return acc += (curr.getUnitPrice() * curr.quantity)
    }, 0)
    return totalPrice
  },
  getTmpCartTotal: (state) => {
    let totalPrice = state.tmpCart.items.reduce((acc, curr) => {
      return acc += (curr.getUnitPrice() * curr.quantity)
    }, 0)
    return totalPrice
  },
  getOldCart: state => state.oldCart,
  isCartRecoveryAvailable: (state, getters) => {
    if (!getters.isAuthenticated) return false
    if (getters.getItems.length > 0) return false
    if (Object.keys(getters.getOldCart).length <= 0) return false
    if (getters.getOldCart.items.length <= 0) return false

    return true
  },
}

/**
 * ==============================
 * ACTIONS
 * ==============================
 */

const actions = {
  [AUTH_SUCCESS]: ({ commit, state, getters }, { token }) => {
    return new Promise(async (resolve, reject) => {
      if (getters.getItems.length > 0) {
        if (state.cart.userToken !== token) {
          commit(RESET_CART)
        } else {
          // Si le panier en cours possède un customer, on l'attribue directement à la session
          if (Object.keys(state.cart.customer).length > 0) {
            commit(SET_CUSTOMER, state.cart.customer)
          }
        }
      } else {
        commit(SET_CART_USER_TOKEN, token)
      }
      commit(SAVE_CART)
      resolve()
    })
  },
  [SET_CUSTOMER]: ({ commit }, customer) => {
    commit(SET_CART_CUSTOMER, customer)
    commit(SAVE_CART)
  },
  [CART_CONFIRM]: ({ commit, state, getters }, orderContent) => {
    return new Promise(async (resolve, reject) => {
      let customerApiToken = null
      if (getters.hasCustomer) {
        customerApiToken = getters.getCustomer.apiToken
      }
      let cart = formatCart(state.cart)
      OrdersRepository.postOrder({ cart: cart, orderContent }, customerApiToken)
        .then(({ data }) => {
          commit(SET_SNACK, {
            message: 'Commande validée',
            color: 'success',
          })
          resolve(data)
        }).catch(err => {
          commit(SET_SNACK, {
            message: 'Erreur lors de la validation',
            color: 'error',
          })
          reject(err)
        })
    })
  },
  [ADD_TO_CART]: ({ commit }, item) => {
    return new Promise(async (resolve, reject) => {
      commit(ADD_TO_CART, item)
      commit(SAVE_CART)
      commit(SHOW_CART)
      commit(RESET_TMP_CART)
      commit(SET_SNACK, {
        message: 'Ajouté au panier',
        color: 'success',
      })
      resolve()
    })
  },
  [REMOVE_FROM_CART]: ({ commit }, item) => {
    return new Promise(async (resolve, reject) => {
      commit(REMOVE_FROM_CART, item)
      commit(SAVE_CART)
      resolve()
    })
  },
  [RESET_CART]: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      commit(RESET_CART)
      commit(SAVE_CART)
      resolve()
    })
  },
  [CHANGE_ITM_QTY]: ({ commit, state }, item) => {
    return new Promise(async (resolve, reject) => {
      if (item.qty == 0) {
        let found = state.cart.items.find(cartItem => {
          return cartItem.id == item.id
        })
        if (found) {
          commit(REMOVE_FROM_CART, found)
        }
      } else {
        commit(CHANGE_ITM_QTY, item)
      }
      commit(SAVE_CART)
      resolve()
    })
  },
  [STORE_OLD_CART]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(STORE_OLD_CART)
      commit(SAVE_CART)
      resolve()
    })
  },
  [RECOVER_OLD_CART]: ({ commit, state }) => {
    return new Promise(async (resolve, reject) => {
      if (Object.keys(state.oldCart).length > 0) {
        commit(RECOVER_OLD_CART)
        commit(UPDATE_TOTAL_QTY)
        commit(SAVE_CART)
        commit(SET_SNACK, {
          message: 'Panier restauré',
          color: 'success',
        })
      }
      resolve()
    })
  },
  [RESET_CART_ITEMS]: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      commit(RESET_CART_ITEMS)
      commit(SAVE_CART)
      resolve()
    })
  },
  [UPDATE_CART]: ({ commit }, { token, customer }) => {
    return new Promise((resolve, reject) => {
      commit(UPDATE_CART, { token, customer })
      commit(UPDATE_TOTAL_QTY)
      commit(SAVE_CART)
      resolve()
    })
  },
  [COMPARE_OLD_CART]: ({ commit }, data) => {
    commit(COMPARE_OLD_CART, data)
    commit(SAVE_CART)
  },
}

/**
 * ==============================
 * MUTATIONS
 * ==============================
 */

const mutations = {
  [ADD_TO_CART]: (state, item) => {
    if (state.cart.items.length <= 0) {
      state.cart.guid = generateUniqId()
    }
    let found = state.cart.items.find(cartItem => {
      return (
        (cartItem.reference.id == item.reference.id) 
        && (cartItem.color.id == item.color.id) 
        && (cartItem.size.id == item.size.id))
    })

    if (found) {
      found.quantity += parseInt(item.quantity)
    } else {
      state.cart.items.push(item)
    }
    state.totalQty += parseInt(item.quantity)
  },
  [ADD_TO_TMP_CART]: (state, item) => {
    let found = state.tmpCart.items.find(cartItem => {
      return (
        (cartItem.reference.id == item.reference.id) 
        && (cartItem.color.id == item.color.id) 
        && (cartItem.size.id == item.size.id))
    })

    if (found) {
      found.quantity = parseInt(item.quantity)
    } else {
      state.tmpCart.items.push(item)
    }
  },
  [REMOVE_FROM_CART]: (state, item) => {
    let index = state.cart.items.indexOf(item)

    if (index > -1) {
      let quantity = state.cart.items[index].quantity
      state.totalQty -= parseInt(quantity)

      state.cart.items.splice(index, 1)
    }
  },
  [REMOVE_FROM_TMP_CART]: (state, item) => {
    let found = state.tmpCart.items.findIndex(cartItem => {
      return (
        (cartItem.reference.id == item.reference) 
        && (cartItem.color.id == item.color) 
        && (cartItem.size.id == item.size))
    })

    if (found > -1) {
      state.tmpCart.items.splice(found, 1)
    }
  },
  [RESET_CART]: state => {
    state.cart     = defaultCart
    state.totalQty = 0
  },
  [RESET_TMP_CART]: state => {
    state.tmpCart = {
      items: [],
    }
  },
  [CHANGE_ITM_QTY]: (state, item) => {
    let found = state.cart.items.find(cartItem => {
      return cartItem.id == item.id
    })

    if (found) {
      let subQty = parseInt(found.quantity) - parseInt(item.qty)
      if (subQty > 0) {
        state.totalQty -= subQty
      } else {
        state.totalQty += Math.abs(subQty)
      }
      found.quantity = parseInt(item.qty)
    }
  },
  [SAVE_CART]: state => {
    window.localStorage.setItem('cart', JSON.stringify(state.cart))
    window.localStorage.setItem('totalQty', state.totalQty)
    if (Object.prototype.hasOwnProperty.call(state, 'oldCart')) {
      window.localStorage.setItem('oldCart', JSON.stringify(state.oldCart))
    }
  },
  [SHOW_CART]: state => {
    state.cartShown = true
  },
  [HIDE_CART]: state => {
    state.cartShown = false
  },
  [SET_CART_VISIBILITY]: (state, value) => {
    state.cartShown = value
  },
  [SET_CART_USER_TOKEN]: (state, value) => {
    state.cart.userToken = value 
  },
  [SET_CART_CUSTOMER]: (state, value) => {
    state.cart.customer = value
  },
  [RESET_CART_ITEMS]: state => {
    state.cart.items = []
    state.totalQty   = 0
  },
  [STORE_OLD_CART]: state => {
    state.oldCart = JSON.parse(JSON.stringify(state.cart))
  },
  [RECOVER_OLD_CART]: state => {
    state.cart = JSON.parse(JSON.stringify(state.oldCart))
    state.cart.items.forEach((item, i) => {
      item.getUnitPrice = function() {
        if (this.discount !== null) {
          return parseFloat(this.unitPrice * (1 - (this.discount / 100)))
        }
  
        return parseFloat(this.unitPrice)
      }
    })
  },
  [UPDATE_TOTAL_QTY]: state => {
    let totalQty = state.cart.items.reduce((acc, curr) => {
      return acc += curr.quantity
    }, 0)
    state.totalQty = totalQty
  },
  [RESET_OLD_CART]: state => {
    state.oldCart = {}
  },
  [UPDATE_CART]: (state, { token, customer }) => {
    if (!Object.prototype.hasOwnProperty.call(state.cart, 'userToken') || [null, ''].includes(state.cart.userToken)) {
      state.cart.userToken = token
    }
    if (!Object.prototype.hasOwnProperty.call(state.cart, 'customer') || Object.keys(state.cart.customer).length <= 0) {
      if (Object.keys(customer).length > 0) {
        state.cart.customer = customer
      }
    }
  },
  [COMPARE_OLD_CART]: (state, { guid }) => {
    if (Object.prototype.hasOwnProperty.call(state.oldCart, 'guid')) {
      if (guid === state.oldCart.guid) {
        state.oldCart = {}
      }
    }
  },
}

function formatCart(cart) {
  let items = []
  cart.items.forEach(item => {
    items.push({
      id: item.id,
      referenceId: item.reference.id,
      colorId: item.color.id,
      sizeId: item.size.id,
      quantity: item.quantity,
      unitPrice: item.unitPrice,
      discount: item.discount,
    })
  })

  return {
    guid: cart.guid,
    items: items,
    customer: cart.customer,
    userToken: cart.userToken,
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}